module.exports = __webpack_public_path__ + "img/tab5.fb556f30.png";